/* ==========================================================================
   Vídeos de la galería de la landing de convención y de la página de vídeos
   (Conventions desde el 13-oct-2026, sección gyaa-videos).

   Arrancan pausados y en silencio: el Figma no dibuja ninguna pista de vídeo,
   así que el botón de play es un añadido funcional. Nada de autoplay — cuatro
   vídeos arrancando solos en móvil fue justo lo que se descartó en la spec del
   5-ago.
   ========================================================================== */

(function () {
  'use strict';

  /** Pausa y silencia los demás: dos vídeos sonando a la vez es inaceptable. */
  function stopOthers(current) {
    var videos = document.querySelectorAll('[data-conv-gallery-item] video');
    for (var i = 0; i < videos.length; i++) {
      if (videos[i] === current) continue;
      videos[i].pause();
      videos[i].muted = true;
      videos[i].removeAttribute('controls');
      var cell = videos[i].closest('[data-conv-gallery-item]');
      var other = cell && cell.querySelector('[data-conv-play]');
      if (other) other.hidden = false;
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-conv-play]');
    if (!btn) return;

    var cell = btn.closest('[data-conv-gallery-item]');
    var video = cell && cell.querySelector('video');
    if (!video) return;

    stopOthers(video);
    video.muted = false;
    video.setAttribute('controls', '');

    var played = video.play();
    /* Si el navegador bloquea la reproducción con sonido, se reintenta en
       silencio: mejor que dejar un botón que no hace nada. Solo ese caso
       (NotAllowedError): si el play se cancela porque se pulsó otro vídeo
       antes de que arrancara (AbortError, red lenta), se queda parado; antes
       volvía a arrancar en silencio por detrás (13-oct-2026). */
    if (played && played.catch) {
      played.catch(function (error) {
        if (!error || error.name !== 'NotAllowedError') return;
        video.muted = true;
        video.play();
      });
    }
    btn.hidden = true;
  });
})();
